export enum Pillars {
  Environmental = 1,
  Social = 2,
  Governance = 3
}
